import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTokenCallback } from '../../utils/hooks/useTokenCallback';
import { Translate } from '../../language';
import { addToBag } from '../../actions/marketPlaceActions';
import { Link } from 'react-router-dom';
import { seePointPackages } from '../../actions/markActions';
import { formatPrice } from '../../utils/functions';
import ShowCasePoins from '../../containers/MarketPlace/ShowCasePoints/ShowCasePoints';



const MarketPlacePoints = () => {
    const { listPointPackages } = useSelector(state =>state.markAdmin)
   // console.log();
    const dispatch = useDispatch()


    useTokenCallback(() => {
        dispatch(seePointPackages())
    }, [])
    return <ShowCasePoins consolidateProducts={listPointPackages}/>
    return (
        <div>
            <div className='wrapper-2 column-gap row-gap mt-3'>
                <Link to = "/ShoppingBag">Ir a la ecoBolsa</Link>
                {
                    listPointPackages.map((item, index) => (
                        <div key={index} className="card-admin">
                            <div className="tittle-card-admin">{item.pointsQuantity} puntos</div>
                            <div className="tittle-card-admin">description:{item.description}</div>
                            <div className="tittle-card-admin">Precio:{formatPrice(item.price)}</div>
                            <div className="content-buttom-create">
                                <button type='button' className={`btns-admin btn-create-edit btns-admin-inactive`}
                                onClick={()=>{
                                    dispatch(addToBag (item))
                                }}
                                >{Translate('addToBag', 'es')}</button>
                            </div>

                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default MarketPlacePoints
